import user from './user/reducers'
import menu from './menu/reducers'
import settings from './settings/reducers'

export default {
  user,
  menu,
  settings
}
